import { useNavigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import EditHolidayModal from 'modules/locations/components/AddHoliday'

const EditHolidayModalPage = () => {
  const { navigation } = useNavigation()
  const { id, holidayId } = useStrictParams<'id' | 'holidayId'>()
  const navigate = useNavigate()

  const onClose = () => {
    navigate(navigation.settings.locations.locationsId.holidays.fullPath({ id }))
  }

  return <EditHolidayModal locationId={+id} holidayId={+holidayId} onClose={onClose} />
}

export default EditHolidayModalPage
